module.exports = __webpack_public_path__ + "img/int-pointe.2988310a.png";